var MouseHelper = /** @class */ (function () {
    function MouseHelper(container) {
        this.container = container;
        this.setPosition({ x: 0, y: 0 });
    }
    MouseHelper.prototype.setPosition = function (event) {
        if (!this.container) {
            return;
        }
        var rectSize = this.container.getBoundingClientRect();
        var width = rectSize.width;
        this.center = width / 2;
        this.relativeX = event.clientX - rectSize.left;
        this.relativeY = event.clientY - rectSize.top;
    };
    MouseHelper.prototype.getNewSliderAngle = function () {
        var angleBetweenTwoVectors = Math.atan2(this.relativeY - this.center, this.relativeX - this.center);
        return (angleBetweenTwoVectors + (3 * Math.PI) / 2) % (2 * Math.PI);
    };
    return MouseHelper;
}());
export { MouseHelper };
//# sourceMappingURL=index.js.map